import React from 'react';
import '../../index.css';

export default function Services() {
  return <h1 className="services">SERVICES</h1>;
}
